import { EstrategiasFornecedorInicial, EstrategiasFornecedorModel } from "../models/estrategiasFornecedorModel"
import { EstrategiasFornecedorAction, EstrategiasFornecedorActionsTypes } from "./estrategiasFornecedorActions"

export function estrategiasFornecedorReducer(
    state: EstrategiasFornecedorModel = EstrategiasFornecedorInicial,
    action: EstrategiasFornecedorAction
): EstrategiasFornecedorModel {
    switch (action.type) {
        case EstrategiasFornecedorActionsTypes.CARREGAR:
            return { ...action.payload }
        default:
            return state
    }
}
